import React, {Component} from "react";
import {Form} from "semantic-ui-react";
import {connect} from "react-redux";
import {languages} from "../utils/common";

const mapStateToProps = (state, ownProps) => {
    const {user} = state;
    return {
        ...ownProps,
        lang: user.lang,
    }
}

class ErrorInputAdditionalInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            localValue: "",
            hasError: null,
        };
    }

    componentDidMount() {
        this.setState({localValue: this.props.value});
    }

    render() {
        const {hasError, localValue} = this.state;
        const {onChange, label, name, value, required, width, error, lang, dispatch, ...otherFormInputProps} = this.props;
        return (
            <Form.Field width={width} >
                <Form.Input name={name}
                            fluid required={required} label={label} error={(hasError && required) || !!error}
                            value={localValue}
                            onChange={(event, {value, name})=>{
                                this.setState({localValue: value});
                                onChange(event, {value, name});
                            }}
                            onFocus={() => {
                                this.setState({hasError: false});
                            }}
                            onBlur={(e) => {
                                const val = e.target.value;
                                if(required && (!val || val.length === 0)){
                                    this.setState({hasError: true});
                                }
                            }}

                            {...otherFormInputProps}/>
                {(!!(hasError && required) || !!error) && <small className={"errorText"}>
                    {languages.ENGLISH === lang ? 'Required' : 'Requerido'}
                </small>}
            </Form.Field>

        );
    }
}

export default connect(mapStateToProps)(ErrorInputAdditionalInfo);